/**
 * Upload Road Photo
 * 
 * JS scripts that helps with the road photo uploads
 */

import { getUrl } from "../globals/url";

// Function to insert the Road ID to an hidden input into the photo submission form
const setRoadId = () => {
    if( document.querySelector('.road-photo-submission') ) {
        const uploadForm = document.querySelector('.road-photo-submission');
        const roadIdInput = uploadForm.elements[2]; // @DEVS watch out here, this assumes that the form elements dont get re-arrange
        const roadId = sessionStorage.getItem('road_id');

        roadIdInput.value = roadId;
    }
}

// Function to check if user completed vote submision which sets a road_id session
const checkRoadId = () => {
    let status = false;

    // Only show the CTA if we have a road_id session
    if( sessionStorage.getItem('road_id') ) {
        const uploadButton = document.querySelector('.secondary-cta-bar');
              status       = true;

        if(uploadButton) {
            uploadButton.style.display = 'block';

            setTimeout(() => {
                uploadButton.classList.add('-visible');
            }, 100)
        }
    }

    return status;
}

// Crafting and setting the road edit url in the road photo upload form
const setRoadEditUrl = () => {
    const body = document.querySelector('body');
    const en_url  = body.getAttribute('data-en-url');

    if( document.querySelector('.road-photo-submission') ) {
        const baseUrl = en_url; 
        const uploadForm = document.querySelector('.road-photo-submission');
        const roadUrlInput = uploadForm.elements[3]; // @DEVS watch out here, this assumes that the form elements dont get re-arrange
        const roadId = sessionStorage.getItem('road_id');
        const editUrl = `${baseUrl}wp-admin/post.php?post=${roadId}&action=edit&classic-editor`;

        roadUrlInput.value = editUrl;
    }
}

// Crafting and setting the club slug in the road upload phot
const setClub = () => {
    if( document.querySelector('.road-photo-submission') ) {
        const baseUrl = getUrl(); 
        const uploadForm = document.querySelector('.road-photo-submission');
        const clubInput = uploadForm.elements[4]; // @DEVS watch out here, this assumes that the form elements dont get re-arrange
        const club = document.getElementById('primary').dataset.club;

        clubInput.value = club;
    }
}

document.onreadystatechange = () => {
	if (document.readyState === 'complete') {
		const status = checkRoadId();

        if(status) {
            setRoadId();
            setRoadEditUrl();
            setClub();
        }
	}
};